import {
  DEMO_IAM_PASSWORD,
  DEMO_TENANT_PASSWORD,
  SPECIALTY_DEMO_TENANTS,
  listAllDemoProfileAccounts,
} from "../../demo/demo-tenants.catalog";

const PERSIST_KEY = "itaas:mock-passwords:v1";

export { DEMO_IAM_PASSWORD };

function load(): Record<string, string> {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(PERSIST_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, string>;
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function save(store: Record<string, string>): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(PERSIST_KEY, JSON.stringify(store));
}

let passwords = load();

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export const DEFAULT_TENANT_ADMIN_PASSWORD = "Welcome123!";
export const DEMO_DEFAULT_PASSWORD = "Demo@123456";
/** Mot de passe IAM local (tenant `demo`) — aligné sur le seed ITaaS IAM. */

/** Comptes IAM démo — même identifiants que Suite (localhost:3000). */
export const DEMO_IAM_ACCOUNT_EMAILS = [
  "admin@itaas.demo",
  "hr@itaas.demo",
] as const;

/** Comptes démo RH (tenant `tenant-demo`) — mot de passe unifié si non défini. */
export const DEMO_RH_ACCOUNT_EMAILS = [
  "admin@itaas.local",
  "hr@itaas.local",
  "payroll@itaas.local",
  "employee@itaas.local",
  "manager@itaas.local",
  "customer@itaas.local",
  "deals@itaas.local",
  "leads@itaas.local",
  "recruitment@itaas.local",
  "attendance@itaas.local",
  "finance@itaas.local",
  "itadmin@itaas.local",
  "asset@itaas.local",
  "helpdesk@itaas.local",
  "john@itaas.local",
  "super@itaas.local",
] as const;

/** Initialise les mots de passe démo (idempotent — ne remplace pas un mot de passe déjà défini). */
export function ensureDemoPasswords(): void {
  for (const email of DEMO_RH_ACCOUNT_EMAILS) {
    if (!hasStoredPassword(email)) {
      setStoredPassword(email, DEMO_DEFAULT_PASSWORD);
    }
  }
  for (const email of DEMO_IAM_ACCOUNT_EMAILS) {
    if (!hasStoredPassword(email)) {
      setStoredPassword(email, DEMO_IAM_PASSWORD);
    }
  }
  for (const tenant of SPECIALTY_DEMO_TENANTS) {
    if (!hasStoredPassword(tenant.adminEmail)) {
      setStoredPassword(tenant.adminEmail, DEMO_TENANT_PASSWORD);
    }
  }
  for (const profile of listAllDemoProfileAccounts()) {
    if (!hasStoredPassword(profile.email)) {
      setStoredPassword(profile.email, DEMO_TENANT_PASSWORD);
    }
  }
}

export function hasStoredPassword(email: string): boolean {
  return normalizeEmail(email) in passwords;
}

export function getStoredPassword(email: string): string | undefined {
  return passwords[normalizeEmail(email)];
}

export function setStoredPassword(email: string, password: string): void {
  passwords = {
    ...passwords,
    [normalizeEmail(email)]: password,
  };
  save(passwords);
}

export function verifyStoredPassword(email: string, password: string): boolean {
  const stored = getStoredPassword(email);
  if (!stored) return false;
  return stored === password;
}

export function resetPasswordStore(): void {
  passwords = {};
  save(passwords);
}
